<template>
  <div
    :class="['modal', { 'modal-sp-fullscreen': !noSpFullscreen }, 'in']"
    style="display: block; padding-right: 15px;"
    @click.self="handleBackgroundClick"
  >
    <div :class="['modal-dialog', `modal-${modalSize}`]">
      <div class="modal-content">
        <div
          v-if="!noShowHeader"
          class="tourHotelPlaceModal_topbar d-flex flex-row justify-content-between align-items-center"
        >
          <div class="tourHotelPlaceModal_title" style="width: 100%;">
            <slot name="topbarTitle" />
          </div>
          <tk-button class="btn-link tourHotelPlaceModal_close" @click="close">
            {{ closeText }}<tk-icon name="close" :alt="altText" />
          </tk-button>
        </div>
        <tk-button
          v-if="inlineClose"
          class="btn-link tourHotelPlaceModal_close tourHotelPlaceModal_close_inline"
          @click="close"
        >
          {{ closeText }}<tk-icon name="close" />
        </tk-button>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { removeFromDom } from '@ota-frontend/core/helpers/element'
import TkIcon from '../TkIcon/TkIcon'
import TkButton from '../TkButton/TkButton'
import ModalMixin from './modal-mixin'

export default {
  name: 'TkGlobalModal',
  components: {
    TkIcon,
    TkButton,
  },
  mixins: [ModalMixin],
  props: {
    modalSize: {
      type: String,
      default: '',
    },
    noShowHeader: {
      type: Boolean,
      default: false,
    },
    closeText: {
      type: String,
      default: '',
    },
    noSpFullscreen: {
      type: Boolean,
      default: false,
    },
    inlineClose: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    altText() {
      return this.closeText ? this.closeText : '閉じる'
    },
  },
  mounted() {
    document.body.appendChild(this.$el)
    // to make sure removing element only after destroying all listeners
    this.$once('hook:destroyed', () => {
      removeFromDom(this.$el)
    })
  },
}
</script>
